<template>
    <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg"><path fill="#627EEA" d="M0 0h56v56H0z"/><path d="M28 8v14.783l12.5 5.584L28 8z" fill="#fff" fill-opacity=".6"/><path d="M28 8L15.5 28.367 28 22.783V8z" fill="#fff"/><path d="M28 37.95V48l12.5-17.3L28 37.95z" fill="#fff" fill-opacity=".6"/><path d="M28 48V37.95L15.5 30.7 28 48z" fill="#fff"/><path d="M28 35.617l12.5-7.25L28 22.783v12.834z" fill="#fff" fill-opacity=".2"/><path d="M15.5 28.367l12.5 7.25V22.783l-12.5 5.584z" fill="#fff" fill-opacity=".6"/></svg>
</template>
<script>
export default {
    props:{
     },
    data(){
        return {
        }
    },
}
</script>
